import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d419d1a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Lodging", -1))
const _hoisted_2 = { class: "hotel-links" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LodgingLink = _resolveComponent("LodgingLink")!

  return (_openBlock(), _createElementBlock("section", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_LodgingLink, {
        bookingUrl: "https://www.marriott.com/events/start.mi?id=1681916636739&key=GRP",
        hotel: _ctx.fourPointsHotel,
        googleMapsUrl: "https://goo.gl/maps/9G3Z62niVAV7z9s99",
        imageName: 'four-points.jpg',
        imageDescription: "The front of the Four Points hotel, with a covered entry vestibule and at least 8 stories of concrete and glass guest rooms visible.",
        name: "Four Points by Sheraton"
      }, null, 8, ["hotel", "imageName"]),
      _createVNode(_component_LodgingLink, {
        bookingUrl: 'https://hotelstudioallston.reztrip.com/ext/promoRate?property=1604&mode=b&pm=true&sr=833345&vr=3',
        hotel: _ctx.allstonStudioHotel,
        imageDescription: "The front of the Studio Allston hotel, a 5 story white facade with some artistic diagonal black lines and teal color blotches.",
        imageName: 'studio-allston.jpg',
        googleMapsUrl: "https://goo.gl/maps/assqRzCbE5KKrPjK7",
        name: "Studio Allston"
      }, null, 8, ["bookingUrl", "hotel", "imageName"])
    ])
  ]))
}